/**
 * Theme Requirements Aggregation for Pillar Properties
 * 
 * Extends the base avenue theme requirements with Pillar Properties specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-avenue/requirements';

/**
 * Pillar Properties component requirement overrides.
 * Add requirements for any override components here.
 */
const pillarpropertiesOverrides: Record<string, ComponentRequirements> = {
  // Example:
  // Footer: FooterRequirements,
};

/**
 * All component requirements for the Pillar Properties theme.
 * Inherits from avenue theme and overrides with Pillar Properties components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...pillarpropertiesOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
